<script setup>
import { onMounted, onBeforeUnmount } from 'vue'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

onMounted(() => {
	const mask = document.querySelector('.unique-creations')

	if (mask) {
		gsap.fromTo(
			mask,
			{ opacity: 0 },
			{
				opacity: 1,
				duration: 0.5,
				delay: 0,
				ease: 'power2.out',
				scrollTrigger: {
					trigger: '.unique-creations',
					start: 'top-=10% top', // верх блока встретил верх экрана
					toggleActions: 'play none none none',
					// play при входе, дальше ничего
				},
			},
		)
	}
})

onBeforeUnmount(() => {
	ScrollTrigger.getAll().forEach((trigger) => trigger.kill())
})
</script>

<template>
	<section class="unique-creations">
		<div class="unique-creations__container">
			<div class="unique-creations__wrapper">
				<div class="unique-creations__title">
					<h2><span>Мы делаем</span> то, чего не может никто</h2>
				</div>
				<div class="unique-creations__blocks">
					<div class="unique-creations__block unique-creations__block-left">
						<div class="unique-creations__item">
							<div class="unique-creations__bg-elem unique-creations__bg-elem-bad-1">
								<img
									src="@/assets/img/unique-creations/unique-creations_gif-bad-1.gif"
									alt=""
								/>
							</div>
							<div class="unique-creations__bg-elem unique-creations__bg-elem-bad-2">
								<img
									src="@/assets/img/unique-creations/unique-creations_gif-bad-2.gif"
									alt=""
								/>
							</div>
							<div class="unique-creations__bg-elem unique-creations__bg-elem-bad-3">
								<img
									src="@/assets/img/unique-creations/unique-creations_gif-bad-3.gif"
									alt=""
								/>
							</div>
							<div class="unique-creations__img">
								<img
									src="@/assets/img/unique-creations/unique-creations_img-left.png"
									alt=""
								/>
							</div>
							<div class="unique-creations__desc">
								<h3>Другие маски</h3>
								<ul>
									<li>лицо на провисшем мешке</li>
									<li>плохое качество</li>
								</ul>
							</div>
						</div>
					</div>

					<div class="unique-creations__block unique-creations__block-right">
						<div class="unique-creations__item">
							<div class="unique-creations__bg-elem unique-creations__bg-elem-good-1">
								<img
									src="@/assets/img/unique-creations/unique-creations_gif-good-1.gif"
									alt=""
								/>
							</div>
							<div class="unique-creations__bg-elem unique-creations__bg-elem-good-2">
								<img
									src="@/assets/img/unique-creations/unique-creations_gif-good-2.gif"
									alt=""
								/>
							</div>
							<div class="unique-creations__bg-elem unique-creations__bg-elem-good-3">
								<img
									src="@/assets/img/unique-creations/unique-creations_gif-good-3.gif"
									alt=""
								/>
							</div>
							<div class="unique-creations__img">
								<img
									src="@/assets/img/unique-creations/unique-creations_img-right.png"
									alt=""
								/>
							</div>
							<div class="unique-creations__desc" id="about">
								<h3>«на лицо»</h3>
								<ul>
									<li>настоящая смена лица</li>
									<li>облегает голову</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<style lang="scss" scoped>
.unique-creations {
	height: 98.7rem;
	position: relative;
	padding: 10.3rem 0 0;

	@media (max-width: 991.98px) {
		height: 68.2rem;
		padding-top: 3.6rem;
	}

	// .unique-creations__container
	&__container {
	}

	// .unique-creations__wrapper
	&__wrapper {
	}

	// .unique-creations__title
	&__title {
		margin: 0 auto;
		max-width: 44rem;
	}

	// .unique-creations__blocks
	&__blocks {
		@media (max-width: 991.98px) {
			max-width: 36rem;
			margin: 2.5rem auto 0;
			position: relative;
		}
	}

	// .unique-creations__block
	&__block {
		width: 100%;
		position: absolute;

		&:first-child {
			max-width: 45.6rem;
			top: 7.8rem;
			left: 19.8rem;

			@media (max-width: 991.98px) {
				max-width: 17.3rem;
				left: 0rem;
				top: 0.7rem;
			}
		}

		&:last-child {
			max-width: 51.7rem;
			top: 6.6rem;
			right: 17.5rem;

			@media (max-width: 991.98px) {
				max-width: 19.5rem;
				right: 0rem;
				top: 18.8rem;
			}
		}
	}

	// .unique-creations__item
	&__item {
		width: 100%;
	}

	// .unique-creations__bg-elem
	&__bg-elem {
		position: absolute;
		mix-blend-mode: lighten;
		z-index: 0;
		pointer-events: none;
		user-select: none;

		@media (max-width: 991.98px) {
			z-index: 2;
		}

		img {
			width: 100%;
			height: 100%;
			object-fit: contain;
		}
	}

	// .unique-creations__bg-elem-bad-1
	&__bg-elem-bad-1 {
		max-width: 11rem;
		top: 3rem;
		right: 1rem;

		@media (max-width: 991.98px) {
			max-width: 3.5rem;
			top: -1.3rem;
			right: 0.5rem;
		}
	}

	// .unique-creations__bg-elem-bad-2
	&__bg-elem-bad-2 {
		max-width: 9.5rem;
		top: 42rem;
		right: -8.5rem;
		transform: rotate(12deg);

		@media (max-width: 991.98px) {
			max-width: 3rem;
			top: 14.2rem;
			right: -3.5rem;
		}
	}

	// .unique-creations__bg-elem-bad-3
	&__bg-elem-bad-3 {
		max-width: 9rem;
		bottom: 21.3rem;
		left: -6.9rem;

		@media (max-width: 991.98px) {
			max-width: 3.5rem;
			bottom: 1.5rem;
			left: -0.3rem;
			transform: rotate(-7deg);
		}
	}

	// .unique-creations__bg-elem-good-1
	&__bg-elem-good-1 {
		max-width: 9rem;
		top: -2rem;
		left: 3rem;
		transform: rotate(9deg);

		@media (max-width: 991.98px) {
			max-width: 2.5rem;
			top: 15rem;
			left: -4.4rem;
		}
	}

	// .unique-creations__bg-elem-good-2
	&__bg-elem-good-2 {
		max-width: 9rem;
		bottom: 33.5rem;
		left: -11.1rem;
		transform: rotate(-24deg);

		@media (max-width: 991.98px) {
			max-width: 3rem;
			bottom: -1.5rem;
			left: -4rem;
		}
	}

	// .unique-creations__bg-elem-good-3
	&__bg-elem-good-3 {
		max-width: 11rem;
		bottom: 12rem;
		right: -2rem;
		mix-blend-mode: plus-lighter;

		@media (max-width: 991.98px) {
			max-width: 3.5rem;
			bottom: 4rem;
			right: 0.7rem;
			transform: rotate(30deg);
		}
	}

	// .unique-creations__img
	&__img {
		width: 100%;
		height: 100%;
		position: relative;
		z-index: 1;
		pointer-events: none;
		user-select: none;

		img {
			width: 100%;
			height: 100%;
			object-fit: contain;
		}
	}

	// .unique-creations__desc
	&__desc {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 3;

		h3 {
			z-index: 1;
			position: absolute;
			display: inline-block;
			background-repeat: no-repeat;
			background-position: center;
			background-size: cover;
			padding: 2.5rem 3.6rem;
			font-weight: 400;
			font-size: 5.8rem;
			// line-height: 5.5rem;
			line-height: 94%;
			text-transform: lowercase;
			text-align: center;
			white-space: nowrap;

			@media (max-width: 991.98px) {
				font-size: 2.6rem;
				// line-height: 2.6rem;
				line-height: 100%;
				padding: 1rem 1.6rem 0.6rem;
			}
		}

		ul {
			li {
				z-index: 0;
				position: absolute;
				font-family: var(--second-font);
				font-weight: 600;
				font-size: 2.4rem;
				// line-height: 2.8rem;
				line-height: 116%;
				border-radius: 1rem;
				padding: 0.2rem 1.6rem 0.8rem;
				background: #101010;
				white-space: nowrap;

				@media (max-width: 991.98px) {
					font-size: 1.6rem;
					// line-height: 1.9rem;
					line-height: 116%;
					border-radius: 0.4rem;
					padding: 0rem 1rem 0.3rem;
				}
			}
		}

		.unique-creations__block-left & {
			h3 {
				color: #fff;
				transform: rotate(-14deg);
				bottom: 17.2rem;
				right: -23.2rem;
				background-image: url('@/assets/img/unique-creations/unique-creations_title-left.png');

				@media (max-width: 991.98px) {
					right: -14.5rem;
					top: 1.8rem;
					bottom: auto;
				}
			}

			ul {
				li {
					color: #ff3250;

					&:first-child {
						transform: rotate(-5deg);
						bottom: 11.7rem;
						right: -19.7rem;

						@media (max-width: 991.98px) {
							right: -15.8rem;
							top: 7.6rem;
							bottom: auto;
						}
					}

					&:last-child {
						transform: rotate(6deg);
						bottom: 6.5rem;
						right: -15.8rem;

						@media (max-width: 991.98px) {
							right: -9.9rem;
							top: 10.9rem;
							bottom: auto;
						}
					}
				}
			}
		}

		.unique-creations__block-right & {
			h3 {
				color: #e2ff04;
				transform: rotate(16deg);
				bottom: 18rem;
				left: -23.2rem;
				background-image: url('@/assets/img/unique-creations/unique-creations_title-right.png');

				@media (min-width: 991.98px) {
					font-size: 6.4rem;
				}

				@media (max-width: 991.98px) {
					left: -10.8rem;
					bottom: 8.5rem;
				}
			}

			ul {
				li {
					color: #e2ff04;

					&:first-child {
						transform: rotate(8deg);
						bottom: 12.3rem;
						left: -22.3rem;

						@media (max-width: 991.98px) {
							left: -12rem;
							bottom: 5.2rem;
						}
					}

					&:last-child {
						transform: rotate(-4deg);
						bottom: 7rem;
						left: -19.4rem;

						@media (max-width: 991.98px) {
							left: -11rem;
							bottom: 2.1rem;
						}
					}
				}
			}
		}
	}
}
</style>
